import React from 'react'

const ChevronLeft = ({ size = 10, color = '#001689', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(size * 6) / 10}   
    height={size}
    viewBox="0 0 6 10"
    fill="none"
    {...props}
  >
    <path
      d="M5 9L1 5L5 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronLeft
